import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CustomHttp, ConfigServerService } from '../../../core';
import { PessoaEnderecoTipo } from '../endereco';
import { PessoaContatoTipo } from '../contato';
import { PessoaEnderecoContato } from '../pessoa-endereco-contato';

@Injectable({
    providedIn: 'root'
})
export class PessoaEnderecoContatoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pessoa`;
    }

    /** Procura o endereço e contato da pessoa e tipos informados */
    findEnderecoEContato(id: number, tipoEndereco: PessoaEnderecoTipo, tipoContato: PessoaContatoTipo): Observable<PessoaEnderecoContato> {
        // Params
        const params = new HttpParams()
                            .append('tipoEndereco', tipoEndereco ? tipoEndereco.id.toString() : 'null')
                            .append('tipoContato', tipoContato ? tipoContato.id.toString() : 'null');

        return this.customHttp.get<PessoaEnderecoContato>(`${this.pathApi}/${id}/enderecocontato`, {params});
    }
}
